<!--
~ Copyright (C) 2017 - present by OpenGamma Inc. and the OpenGamma group of companies
~
~ Please see distribution for license.
-->
<div class="cell cell--{{ options.textAlign }}-align cell--{{ options.cellPadding }}">
  @if (options.arrows && !!arrowValue) {
  <og-arrow [value]="arrowValue" [invertColors]="options.arrows === 'up-red'"></og-arrow>
  } @if (displayPlaceholder) {
  <div class="cell__placeholder"></div>
  } @if (isExpandable && isExpanded) {
  <span class="cell__expandable-icon" [style.margin-left]="4 + level * 14 + 'px'">
    <og-icon name="minus" [stroke]="IconStroke.XThick"></og-icon>
  </span>
  } @if (isExpandable && !isExpanded) {
  <span class="cell__expandable-icon" [style.margin-left]="4 + level * 14 + 'px'">
    <og-icon name="plus" [stroke]="IconStroke.XThick"></og-icon>
  </span>
  } @if (isValueChanged(value, lastEditedValue)) {
  <div class="cell__clear" (click)="onClearClick($event)">
    <og-icon name="x"></og-icon>
  </div>
  } @if (!isEditing) {
  <span
    class="cell__value"
    [class.editable]="options.editable"
    [class.cell__value--with-subtext]="subtext"
    [class.cell__value--with-subtext-right]="subtext && subtext.placement === 'right'"
    [ngStyle]="computeCustomCellStyles()"
  >
    @if (isValueUndefinedOrEmpty() && !(type === 'icon' || type === 'expandableIcon')) {
    <span>
      -
    </span>
    } @switch (type) { @case ('currency') { @if (lastEditedValue && lastEditedValue.price !==
    undefined) {
    <div
      class="currency__value"
      [matTooltip]="getCurrencySymbol(lastEditedValue) + (lastEditedValue.price | number: '1.0-0')"
      [matTooltipPosition]="'right'"
    >
      {{ lastEditedValue | currencyValue: true:'1.2-2' }}
    </div>
    } } @case ('autoBoundCurrency') { @if (lastEditedValue && lastEditedValue.price !== undefined) {
    <div
      class="currency__value"
      [matTooltip]="getCurrencySymbol(lastEditedValue) + (lastEditedValue.price | number: '1.0-0')"
      [matTooltipPosition]="'right'"
    >
      {{ lastEditedValue | boundedCurrencyValue: bound:'1.2-2' }}
    </div>
    } } @case ('date') {
    {{ parseDate(lastEditedValue) | date: 'dd/MM/yyyy' }}
    } @case ('number') {
    {{ lastEditedValue | number: '1.2-2' }}
    } @case ('integer') {
    {{ lastEditedValue | number: '1.0-0' }}
    } @case ('autoBoundNumber') { @if (isValueNumeric()) {
    {{ lastEditedValue | boundedShortNumber: bound:'1.2-2' }}
    } @else {
    {{ lastEditedValue }}
    } } @case ('fixedBoundNumber') { @if (!!lastEditedValue && lastEditedValue.value) {
    <div
      class="currency__value"
      [matTooltip]="lastEditedValue.value | number: '1.0-0'"
      [matTooltipPosition]="'right'"
    >
      {{ lastEditedValue.value | boundedShortNumber: bound:'1.2-2' }}
    </div>
    } } @case ('fixedBoundCurrency') { @if (!!lastEditedValue && lastEditedValue.value) {
    <div
      class="currency__value"
      [matTooltip]="lastEditedValue.value | currencyValue: false:'1.0-0'"
      [matTooltipPosition]="'right'"
    >
      {{ lastEditedValue.value | boundedCurrencyValue: bound:'1.2-2' }}
    </div>
    } } @case ('percent') {
    {{ lastEditedValue | percent: '1.2-2' }}
    } @case ('text') {
    {{ lastEditedValue }}
    } @case ('textList') {
    <div class="value__list">
      @for (value of lastEditedValue; track value) {
      <span>{{ value }}</span>
      }
    </div>
    } @case ('icon') { @if (!!lastEditedValue && !!lastEditedValue.name) { @if (lastEditedValue) {
    <og-icon [size]="lastEditedValue.size" [name]="lastEditedValue.name"></og-icon>
    } } } @case ('expandableIcon') { @if (lastEditedValue && !isExpanded) {
    <og-icon [name]="lastEditedValue.default"></og-icon>
    } @if (lastEditedValue && isExpanded) {
    <og-icon [name]="lastEditedValue.expanded"></og-icon>
    } } @case ('barChart') {
    <div class="cell__bar-chart">
      <div class="bar-chart__legend">
        {{ lastEditedValue.barWidth + '%' }}
      </div>
      <div class="bar-chart__container">
        <div
          class="bar-chart__bar"
          [class.bar-chart__bar--expanded]="isExpanded"
          [style.width]="lastEditedValue.barWidth + '%'"
          [style.backgroundColor]="lastEditedValue.barColor"
        ></div>
      </div>
    </div>
    } @case ('directionalBarChart') {
    <div class="cell__bar-chart">
      <div fxFlex="70px" class="bar-chart__legend">
        <span class="bar-chart__sign--{{ lastEditedValue.direction }}"></span>
        {{ lastEditedValue.value + '%' }}
      </div>
      <div class="bar-chart__container bar-chart__container--left">
        <div
          class="bar-chart__bar bar-chart__bar--left"
          [class.bar-chart__bar--expanded]="isExpanded"
          [style.width]="getDirectionalBarWidth(lastEditedValue, 'left')"
        ></div>
      </div>
      <div fxFlex="1px" class="bar-chart__divider"></div>
      <div class="bar-chart__container bar-chart__container--right">
        @if (lastEditedValue.direction === 'right') {
        <div
          class="bar-chart__bar bar-chart__bar--right"
          [class.bar-chart__bar--expanded]="isExpanded"
          [style.width]="getDirectionalBarWidth(lastEditedValue, 'right')"
        ></div>
        }
      </div>
    </div>
    } } @if (subtext) {
    <span class="cell__subtext" [class.cell__subtext--right]="subtext.placement === 'right'">
      <span [matTooltip]="subtext.tooltip" [matTooltipPosition]="'right'">
        {{ subtext.text }}
      </span>
    </span>
    }
  </span>
  } @if (isEditing) {
  <span class="cell__value">
    @switch (type) { @case ('currency') {
    {{ getCurrencySymbol(value) }}
    <input
      #input
      autofocus
      type="number"
      [(ngModel)]="editedValue.price"
      (blur)="onBlur()"
      (keyup)="onKeyUp($event)"
    />
    } @case ('date') {
    <input
      #input
      autofocus
      type="text"
      [(ngModel)]="editedValue"
      (blur)="onBlur()"
      (keyup)="onKeyUp($event)"
    />
    } @case ('number') {
    <input
      #input
      autofocus
      type="number"
      [(ngModel)]="editedValue"
      (blur)="onBlur()"
      (keyup)="onKeyUp($event)"
    />
    } @case ('integer') {
    <input
      #input
      autofocus
      type="integer"
      [(ngModel)]="editedValue"
      (blur)="onBlur()"
      (keyup)="onKeyUp($event)"
    />
    } @case ('percent') {
    <input
      #input
      autofocus
      type="number"
      [ngModel]="editedValue * 100"
      (change)="onEditPercentage($event)"
      (blur)="onBlur()"
      (keyup)="onKeyUp($event)"
    />
    % } @case ('text') {
    <input
      #input
      type="text"
      [(ngModel)]="editedValue"
      (blur)="onBlur()"
      (keyup)="onKeyUp($event)"
    />
    } @case ('icon') {
    <input
      #input
      type="text"
      [(ngModel)]="editedValue"
      (blur)="onBlur()"
      (keyup)="onKeyUp($event)"
    />
    } }
  </span>
  } @if (isEditing || isValueChanged(value, lastEditedValue)) {
  <div class="cell__original-value">
    @switch (type) { @case ('currency') { Original Value:
    {{ value | currencyValue: true:'1.0-2' }} } @case ('date') { Original Value:
    {{ value | date: 'dd/MM/yyyy' }} } @case ('number') { Original Value:
    {{ value | number: '1.0-2' }} } @case ('integer') { Original Value:
    {{ value | number: '1.0-0' }} } @case ('percent') { Original Value:
    {{ value | percent: '1.0-2' }} } @case ('text') { Original Value: {{ value }}
    } @case ('icon') { Original Value: @if (value) {
    <og-icon [name]="value"></og-icon>
    } } }
  </div>
  }
</div>
